import React, { FC } from 'react';
import Opportunity, { OpportunityProps } from '@/pages/CareersPage/components/Opportunities/Opportunity/Opportunity';
import styles from './Opportunities.module.scss';

export interface OpportunitiesProps {
  jobs: OpportunityProps[];
  opportunitiesLabel: string;
}

const Opportunities: FC<OpportunitiesProps> = ({
  opportunitiesLabel,
  jobs,
}) => (
  <>
    {!!opportunitiesLabel && (
      <div className={styles.title}>
        {opportunitiesLabel}
      </div>
    )}
    <div className={styles.container}>
      {jobs.map((job) => (
        <Opportunity
          key={job.id}
          {...job}
        />
      ))}
    </div>
  </>
);
Opportunities.displayName = 'Opportunities';

export default Opportunities;
